
import React from 'react';
import AboutUs from '../components/AboutUs';
import MissionVision from '../components/MissionVision';
import Footer from '../components/Footer';


function About() {
  return (
    <>
        <AboutUs /> 
        <MissionVision />
        <Footer />
    </>
  );
}


export default About;
